import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { OFFERINGS } from '../mock';
import ClosingCTA from '../components/ClosingCTA';
import SEO from '../components/SEO';

export default function WhatWeDo() {
  return (
    <div>
      <SEO
        title="What we do — advisory, engineering, platform and run"
        description="Four practices, one accountable team. AI Strategy & Advisory, AI-Native Engineering, Platform & Commerce Modernisation, and Run & Optimise — under NeuralWorks."
        canonical="https://digitalworks.co/what-we-do"
      />
      <section className="pt-16 pb-10">
        <div className="dwx">
          <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A]/60">What we do</div>
          <h1 className="serif-tight text-[64px] md:text-[112px] leading-[0.92] mt-4">One team from<br />strategy to production.</h1>
          <p className="mt-10 max-w-3xl text-[17px] leading-relaxed text-[#1A1A1A]/80">Most engagements fail at the handoffs — strategy to design, design to build, build to run. Each transition loses context, and the AI-generated assumptions made in one phase surface as defects three phases later. We do not hand off.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="dwx grid grid-cols-1 md:grid-cols-2 gap-4">
          {OFFERINGS.map((o, i) => (
            <Link key={o.slug} to={`/what-we-do/${o.slug}`} className="group rounded-[24px] bg-[#F4F2EC] p-10 hover:bg-[#E8E4D9] transition-colors lift">
              <div className="flex items-start justify-between">
                <span className="mono text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A]/50">0{i + 1}</span>
                <ArrowUpRight size={22} className="text-[#1A1A1A]/40 group-hover:text-[#22A94F]" />
              </div>
              <h3 className="serif text-[36px] leading-tight mt-8">{o.title}</h3>
              <p className="mt-4 text-[15px] leading-relaxed text-[#1A1A1A]/70">{o.blurb}</p>
            </Link>
          ))}
        </div>
        <div className="dwx mt-10 text-center text-[14px] text-[#1A1A1A]/60">All four run under <Link to="/neuralworks" className="text-[#178838] link-sweep">NeuralWorks</Link> protocols.</div>
      </section>

      <ClosingCTA />
    </div>
  );
}
